<template>
	<form class="bg-white px-6 py-8 xl:px-12 xl:py-10" method="POST" @submit="submitForm">
		<fieldset class="mb-8">
			<label for="tracking-code" class="label">Enter your BOL number</label>
			<ValidationProvider rules="tracking" v-slot="{ errors }" mode="lazy">
				<input
					:class="[
						(trackingCode.error && trackingCode.value == null) || errors.length
							? 'input !border-error'
							: 'input',
					]"
					id="tracking-code"
					name="tracking-code"
					type="text"
					placeholder="BOL Number"
					v-model="trackingCode.value"
				/>
				<span class="form-error" v-if="trackingCode.error && !errors.length">
					{{ trackingCode.error }}
				</span>
				<span class="form-error" v-if="errors.length">{{ errors[0] }}</span>
			</ValidationProvider>
		</fieldset>
		<fieldset>
			<button class="button w-full justify-between" type="submit">
				Find my shipment
				<span class="w-3 h-3">
					<svg
						class="w-full h-full fill-inherit"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 200 200"
					>
						<polygon
							fill-rule="evenodd"
							clip-rule="evenodd"
							points="121.3,21.3 106.3,36.4 159.2,89.3 0,89.3 0,110.7 159.2,110.7
                            106.3,163.6 121.3,178.7 192.4,107.5 200,100 192.4,92.4 "
						/>
					</svg>
				</span>
			</button>
		</fieldset>
	</form>
</template>

<script>
import axios from "axios";
import { forms } from "../../molecules/forms";

// Rules
import "../rules.js";

// Components
import { ValidationProvider } from "vee-validate";

/**
    title: Tracking Code
	data: {
		- trackingCode: Get the value/error of the tracking code submitted
	}
	components: {
		- ValidationProvider: Vee-Validate
	}
    mounted: {
        - forms: Run the forms JS once the instance has mounted
    }
    methods: {
        - submitForm: Send the form data to the predator API
    }
**/
export default {
	data: function () {
		return {
			trackingCode: {
				value: null,
				error: null,
			},
		};
	},
	components: {
		ValidationProvider,
	},
	mounted: function () {
		this.$nextTick(function () {
			// Once the instance has been created, we want to run the the forms script
			forms();
		});
	},
	methods: {
		submitForm: function (e) {
			// Called when the form is submitted
			e.preventDefault();

			// Create a new formData object
			let formData = new FormData();

			// Add the Craft CSRF Token to the FormData - This is required by the PHP Model
			formData.append("CRAFT_CSRF_TOKEN", window.csrfToken);

			// We want to append the tracking code to the formData, and we need to stringify this for it to work
			formData.append("bol", this.trackingCode.value);

			axios
				.post("/actions/predator/tracker/query", formData)
				.then((response) => {
					if (response.data.error) {
						// If an error exists, we want to throw the data to the catch
						throw { response: response.data};
						forms();
					} else {
						this.$emit("findResults", response.data);
						this.trackingCode.error = null;
					}
				})
				.catch((error) => {
					// Get all errors back from the response
					const errors = error.response;

					// Get the errors related to the form fields
					const formError = errors.error;

					// Assign the error back to the data
					this.trackingCode.error = formError.trackingCode;

					// Clear the results
					this.$emit("findResults", null);
				});
		},
	},
};
</script>
